import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../core';
import { PlanStatusEnum } from './plan-status.pipe';


/**
 * Pipe to convert Plan Status enum to display value.
 */
@Pipe({
	name: 'planStatusLabel'
})
export class PlanStatusLabelPipe implements PipeTransform {

	constructor(private readonly langSrv: LanguageService) { }

	transform(planStatus: PlanStatusEnum | null): string {
		switch (planStatus) {
			case PlanStatusEnum.Active: return this.langSrv.labels().PLAN_STATUS_ACTIVE_LABEL;
			case PlanStatusEnum.AdjustedReport: return this.langSrv.labels().PLAN_STATUS_ADJUSTEDREPORT_LABEL;
			case PlanStatusEnum.Revoked: return this.langSrv.labels().PLAN_STATUS_REVOKED_LABEL;
			default: return planStatus ?? '';
		}
	}

}
